// UI strings for the card session's rhythm (lib/studyRules.ts, Axel's decisions of 2026-10-07): a new
// word is shown before it is asked, and new words come in the evening (catch-up always possible).
// Finnish follows docs/FINNISH-STYLE.md; en has the same shape.
import { defineArea } from '../area';

export const cardRhythmFi = {
  /** The button under a new word being shown (its test comes a few cards later). */
  next: 'Jatka',
  /** Tänään with nothing else left before the evening: today's new words wait. */
  eveningHeading: (n: number, hour: number) =>
    n === 1 ? `Päivän uusi sana tulee illalla klo ${hour} jälkeen.` : `Päivän ${n} uutta sanaa tulee illalla klo ${hour} jälkeen.`,
  /** Under a running session before the evening. */
  eveningLine: (hour: number) => `Uudet sanat tulevat illalla klo ${hour} jälkeen.`,
  /** Starts today's new words now (catch-up). */
  startNow: 'Opettele uudet sanat nyt',
};

export const cardRhythmEn: typeof cardRhythmFi = {
  next: 'Continue',
  eveningHeading: (n, hour) =>
    n === 1 ? `Today's new word comes in the evening, after ${hour}:00.` : `Today's ${n} new words come in the evening, after ${hour}:00.`,
  eveningLine: (hour) => `New words come in the evening, after ${hour}:00.`,
  startNow: 'Learn the new words now',
};

// Messages.cardRhythm (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('cardRhythm', cardRhythmFi, cardRhythmEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof cardRhythmFi> {}
}
